import React from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { TrendingDownIcon, AlertTriangleIcon, BanknoteIcon, ActivityIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const lossData = [{
  month: 'Jan',
  technical: 4.5,
  nonTechnical: 9.2
}, {
  month: 'Feb',
  technical: 4.3,
  nonTechnical: 8.9
}, {
  month: 'Mar',
  technical: 4.4,
  nonTechnical: 9.5
}, {
  month: 'Apr',
  technical: 4.1,
  nonTechnical: 8.2
}, {
  month: 'May',
  technical: 4.2,
  nonTechnical: 8.5
}, {
  month: 'Jun',
  technical: 4.0,
  nonTechnical: 7.8
}];
const lossEvents = [{
  region: 'Tembisa',
  techLoss: '125,000',
  nonTechLoss: '340,000',
  value: 850000,
  trend: 'Increasing'
}, {
  region: 'Soweto',
  techLoss: '210,000',
  nonTechLoss: '520,000',
  value: 1200000,
  trend: 'Decreasing'
}, {
  region: 'Kempton Park',
  techLoss: '85,000',
  nonTechLoss: '45,000',
  value: 250000,
  trend: 'Stable'
}, {
  region: 'Boksburg',
  techLoss: '95,000',
  nonTechLoss: '110,000',
  value: 420000,
  trend: 'Decreasing'
}, {
  region: 'Germiston',
  techLoss: '150,000',
  nonTechLoss: '280,000',
  value: 780000,
  trend: 'Increasing'
}];
export function LossAnalytics() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-1339">
      <div className="mb-8" data-id="element-1340">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1341">
          Loss Analytics
        </h1>
        <p className="text-gray-500" data-id="element-1342">
          Analyze infrastructure losses due to technical issues, theft, and
          downtime.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-1343">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1344">
          <div className="p-3 bg-mavis-blue/10 text-mavis-blue rounded-none" data-id="element-1345">
            <ActivityIcon className="w-5 h-5" data-id="element-1346" />
          </div>
          <div data-id="element-1347">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1348">
              Total Technical Loss
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1349">4.2%</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1350">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-1351">
            <AlertTriangleIcon className="w-5 h-5" data-id="element-1352" />
          </div>
          <div data-id="element-1353">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1354">
              Non-Technical Loss
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1355">8.5%</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1356">
          <div className="p-3 bg-red-50 text-red-600 rounded-none" data-id="element-1357">
            <TrendingDownIcon className="w-5 h-5" data-id="element-1358" />
          </div>
          <div data-id="element-1359">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1360">
              Revenue Impact
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1361">
              {formatZAR(2400000)}
            </p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-1362">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-1363">
            <BanknoteIcon className="w-5 h-5" data-id="element-1364" />
          </div>
          <div data-id="element-1365">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-1366">
              Recovery Rate
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-1367">65%</p>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200 mb-8" data-id="element-1368">
        <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1369">
          Loss Breakdown (Last 6 Months)
        </h2>
        <div className="h-80" data-id="element-1370">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1371">
            <ComposedChart data={lossData} margin={{
            top: 10,
            right: 10,
            left: 0,
            bottom: 0
          }} data-id="element-1372">

              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-1373" />

              <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
              fill: '#6b7280',
              fontSize: 12
            }} dy={10} data-id="element-1374" />

              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#6b7280',
              fontSize: 12
            }} data-id="element-1375" />

              <Tooltip contentStyle={{
              borderRadius: '0',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} formatter={(value: number) => [`${value}%`, '']} data-id="element-1376" />

              <Legend verticalAlign="top" height={36} data-id="element-1377" />
              <Bar dataKey="nonTechnical" name="Non-Technical Loss" fill="#E07020" radius={[0, 0, 0, 0]} data-id="element-1378" />

              <Line type="monotone" dataKey="technical" name="Technical Loss" stroke="#0D4F5C" strokeWidth={3} dot={{
              r: 4
            }} data-id="element-1379" />

            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-1380">
        <div className="p-5 border-b border-gray-200 bg-gray-50" data-id="element-1381">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-1382">
            Loss Events by Region
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-1383">
          <table className="w-full text-left border-collapse" data-id="element-1384">
            <thead data-id="element-1385">
              <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-1386">
                <th className="p-4 font-medium" data-id="element-1387">Region</th>
                <th className="p-4 font-medium" data-id="element-1388">Technical Loss (kWh)</th>
                <th className="p-4 font-medium" data-id="element-1389">Non-Technical Loss (kWh)</th>
                <th className="p-4 font-medium" data-id="element-1390">Est. Value</th>
                <th className="p-4 font-medium" data-id="element-1391">Trend</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1392">
              {lossEvents.map((event, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-1393">
                  <td className="p-4 text-sm font-medium text-gray-900" data-id="element-1394">
                    {event.region}
                  </td>
                  <td className="p-4 text-sm font-mono text-gray-600" data-id="element-1395">
                    {event.techLoss}
                  </td>
                  <td className="p-4 text-sm font-mono text-gray-600" data-id="element-1396">
                    {event.nonTechLoss}
                  </td>
                  <td className="p-4 text-sm font-mono font-bold text-gray-900" data-id="element-1397">
                    {formatZAR(event.value)}
                  </td>
                  <td className="p-4" data-id="element-1398">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${event.trend === 'Decreasing' ? 'bg-green-100 text-green-800' : event.trend === 'Increasing' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-1399">

                      {event.trend}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}